import { render, staticRenderFns } from "./CreateItensNotaFiscalView.vue?vue&type=template&id=af4e28a6"
import script from "./CreateItensNotaFiscalView.vue?vue&type=script&lang=js"
export * from "./CreateItensNotaFiscalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports